<!-- eslint-disable vue/no-mutating-props -->
<template>
  <woot-modal :show.sync="show" :on-close="onClose" size="modal-big">
    <woot-modal-header
      :header-title="$t('WHATSAPP_TEMPLATES.MODAL.TITLE')"
      :header-content="modalHeaderContent"
    />
    <div class="row modal-content">
      <templates-picker
        v-if="!selectedWaTemplate"
        :inbox-id="inboxId"
        @onSelect="pickTemplate"
      />
      <template-parser
        v-else
        :template="selectedWaTemplate"
        :inbox-id="inboxId"
        :default-header-image-url="defaultHeaderImageUrl"
        @resetTemplate="onResetTemplate"
        @sendMessage="onSendMessage"
        @saveDefaultImage="onSaveDefaultImage"
      />
    </div>
  </woot-modal>
</template>

<script>
import TemplatesPicker from './TemplatesPicker.vue';
import TemplateParser from './TemplateParser.vue';
import InboxesAPI from 'dashboard/api/inboxes';
import { useAlert } from 'dashboard/composables';
export default {
  components: {
    TemplatesPicker,
    TemplateParser,
  },
  props: {
    inboxId: {
      type: Number,
      default: undefined,
    },
    show: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      selectedWaTemplate: null,
    };
  },
  computed: {
    modalHeaderContent() {
      return this.selectedWaTemplate
        ? this.$t('WHATSAPP_TEMPLATES.MODAL.TEMPLATE_SELECTED_SUBTITLE', {
            templateName: this.selectedWaTemplate.name,
          })
        : this.$t('WHATSAPP_TEMPLATES.MODAL.SUBTITLE');
    },
    // Get current inbox from store
    currentInbox() {
      if (!this.inboxId) return null;
      return this.$store.getters['inboxes/getInbox'](this.inboxId);
    },
    // Get default image URL for the selected template
    defaultHeaderImageUrl() {
      if (!this.selectedWaTemplate || !this.currentInbox) return '';
      const templateName = this.selectedWaTemplate.name;
      const defaultImages = this.currentInbox.template_default_images || {};
      return defaultImages[templateName] || '';
    },
  },
  mounted() {
    // Fetch fresh inbox data when modal opens (to get template_default_images)
    this.$store.dispatch('inboxes/get');
  },
  methods: {
    pickTemplate(template) {
      this.selectedWaTemplate = template;
    },
    onResetTemplate() {
      this.selectedWaTemplate = null;
    },
    onSendMessage(message) {
      this.$emit('on-send', message);
    },
    onClose() {
      this.$emit('cancel');
    },
    async onSaveDefaultImage({ templateName, imageUrl }) {
      if (!this.inboxId || !templateName) return;

      try {
        await InboxesAPI.setTemplateDefaultImage(this.inboxId, templateName, imageUrl);
        // Refresh inboxes to get updated template_default_images
        await this.$store.dispatch('inboxes/get');
        useAlert('Varsayılan görsel kaydedildi');
      } catch (error) {
        useAlert(error.message || 'Görsel kaydedilirken hata oluştu');
      }
    },
  },
};
</script>

<style scoped>
.modal-content {
  padding: 1.5625rem 2rem;
}
</style>
